import auth from '@/store/modules/auth'
import deposits from '@/store/modules/deposits'
import users from '@/store/modules/users'
import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  modules: {
    auth,
    deposits,
    users,
  },
  plugins: [createPersistedState({ key: 'deposit-frontend' })],
})

